import React from 'react';

export default function LoginCard({ header, children }) {
  return (
    <div className="relative w-full max-w-md sm:max-w-lg md:max-w-xl transform origin-center scale-[0.85] z-10">
      <div className="bg-white backdrop-blur-md rounded-2xl shadow-2xl overflow-hidden">
        {header}
        <div className="p-6 sm:p-7 md:p-8">
          {children}
        </div>
      </div>


    </div>
  );
}
